import React, { FC, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import posthog from 'posthog-js';
import OverviewShell from '../overview_shell/OverviewShell';
import { COMPLIANCE_FEATURE_FLAG } from '../compliance_common/ComplianceConstants';

const ContractorClientsOverviewPage: FC<any> = ({
	userType,
	history,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => {
			history.push(`/${userType}/contractor_clients/overview/${key}`);
		},
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = useMemo(() => {
		return [
			{
				key: 'all',
				name: 'All',
			},
			{
				key: 'locations',
				name: 'All Locations',
			},
			...(posthog.isFeatureEnabled(COMPLIANCE_FEATURE_FLAG)
				? [
						{
							key: 'compliance',
							name: 'Compliance',
						},
				  ]
				: []),
		];
	}, []);

	return (
		<>
			<Route
				path={`/${userType}/contractor_clients/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/contractor_clients/overview/all`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Clients"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const ComponentWithoutUserType = withRouter<any, any>(
	connect(mapStateToProps)(ContractorClientsOverviewPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
